<app-header [showCart]="false" header="TERMINAL.TITLE_TERMINAL_LIST"></app-header>
<div class="page" [ngClass.gt-sm]="{ 'desktop': true }">

  <div class="title" fxHide fxShow.gt-sm>
    <!-- Navigation breadcrumbs -->
    <nav id="breadcrumb">
      <ol class="breadcrumbs">
        <li class="breadcrumbs-item">
          <a class="breadcrumbs-link breadcrumbs-link-active">{{ 'TERMINAL.TITLE_TERMINAL_LIST' | translate }}</a>
        </li>
      </ol>
    </nav>
  </div>

  <!-- terminals -->
  <app-item-list [items]="terminalsApiService.terminals$ | async" [loading$]="terminalsApiService.loading$">
  </app-item-list>

</div>
